/*
 * Product card color circles (snippets/jc-product-card.liquid).
 * Hovering a circle fades that color's variant image over the card image; leaving the
 * card fades it back (500ms, see "Card image hover" in jc.css). Clicks are plain links to the variant URL. Delegated on document so
 * cards added later (recently viewed, quick add) work too. Mouse only: touch taps just navigate.
 */
(() => {
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function preview(sw) {
    const card = sw.closest('.vio-card');
    const media = card && card.querySelector('.vio-card__media');
    if (!media) return;
    card.querySelectorAll('.vio-card__sw').forEach((el) => {
      if (el.dataset.swWasSelected === undefined) el.dataset.swWasSelected = el.classList.contains('is-selected') ? '1' : '0';
      el.classList.toggle('is-selected', el === sw);
    });
    let img = media.querySelector('.vio-card__img--swatch');
    if (!sw.dataset.swSrc) {
      if (img) img.classList.remove('is-on');
      return;
    }
    if (!img) {
      img = document.createElement('img');
      img.className = 'vio-card__img vio-card__img--swatch';
      img.alt = '';
      img.decoding = 'async';
      const base = media.querySelector('.vio-card__img--primary');
      img.sizes = (base && base.getAttribute('sizes')) || '25vw';
      media.appendChild(img);
      // commit the hidden state first, or a cached image would snap in with no fade
      void img.offsetWidth;
    }
    if (img.dataset.src !== sw.dataset.swSrc) {
      img.classList.remove('is-on');
      img.dataset.src = sw.dataset.swSrc;
      img.srcset = sw.dataset.swSrcset || '';
      img.src = sw.dataset.swSrc;
    }
    const show = () => { if (img.dataset.src === sw.dataset.swSrc) img.classList.add('is-on'); };
    if (img.complete && img.naturalWidth) show();
    else img.addEventListener('load', show, { once: true });
  }

  function reset(card) {
    const img = card.querySelector('.vio-card__img--swatch');
    if (img) img.classList.remove('is-on');
    card.querySelectorAll('.vio-card__sw').forEach((el) => {
      if (el.dataset.swWasSelected !== undefined) {
        el.classList.toggle('is-selected', el.dataset.swWasSelected === '1');
        delete el.dataset.swWasSelected;
      }
    });
  }

  document.addEventListener('pointerover', (e) => {
    if (!fine.matches || e.pointerType !== 'mouse') return;
    const sw = e.target.closest && e.target.closest('.vio-card__sw');
    if (sw) preview(sw);
  });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const card = e.target.closest && e.target.closest('.vio-card');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    reset(card);
  });
})();
